import {all} from "redux-saga/effects";
import loginWatcher from "../../modules/auth/login/saga/loginWatcher";
import consultationPackagesWatcher from "../../modules/packages/consultationPackages/saga/consultationPackagesWatcher";
import detailPackageWatcher from "../../modules/packages/detailPackage/saga/detailPackageWatcher";
import modificationPackageWatcher from "../../modules/packages/modificationPackage/saga/modificationPackageWatcher";
import nouveauPackageWatcher from "../../modules/packages/nouveauPackage/saga/nouveauPackageWatcher";
import confirmerPaiementSouscriptionWatcher
    from "../../modules/souscriptions/confirmerPaiementSouscription/saga/confirmerPaiementSouscriptionWatcher";
import consultationSouscriptionsWatcher
    from "../../modules/souscriptions/consultationSouscriptions/saga/consultationSouscriptionsWatcher";
import detailsSouscriptionsWatcher
    from "../../modules/souscriptions/detailsSouscription/saga/detailsSouscriptionWatcher";
import historySouscriptionsWatcher
    from "../../modules/souscriptions/historiqueSouscription/saga/historiqueSouscriptionWatcher";
import modificationSouscriptionWatcher
    from "../../modules/souscriptions/modificationSouscription/saga/modificationSouscriptionWatcher";
import nouvelleSouscriptionWatcher
    from "../../modules/souscriptions/nouvelleSouscription/saga/nouvelleSouscriptionWatcher";
import paiementSouscriptionWatcher
    from "../../modules/souscriptions/paiementSouscription/saga/paiementSouscriptionWatcher";
import consultationTransactionsWatcher
    from "../../modules/transactions/consultationTransactions/saga/consultationTransactionsWatcher";
import localReferentielWatcher from "../localReferentiel/saga/localReferentielWatcher";

export default function* rootSaga() {
  yield all([
    localReferentielWatcher(),
    nouveauPackageWatcher(),
    detailPackageWatcher(),
    modificationPackageWatcher(),
    consultationPackagesWatcher(),
    consultationTransactionsWatcher(),
    consultationSouscriptionsWatcher(),
    nouvelleSouscriptionWatcher(),
    detailsSouscriptionsWatcher(),
    historySouscriptionsWatcher(),
    loginWatcher(),
    modificationSouscriptionWatcher(),
    confirmerPaiementSouscriptionWatcher(),
    paiementSouscriptionWatcher(),
  ]);
}
